import { useEffect, useState } from 'react';
import { type File as FileType } from '../common/core-api';
import { useFile } from './file';

export const useImageUrl = (file: FileType | null | undefined, width: number, height: number): string => {
  const [getFile] = useFile();
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!file) {
      setUrl('');
      return;
    }

    const fetchUrl = async () => {
      const src = await getFile({ file, width, height });
      setUrl(src);
    };

    fetchUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file?.hash, width, height]);

  return url;
};
